/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReportResponseDTO { 
    title?: string;
    exportDate?: string;
    dateRange?: number;
    startDate?: string;
    endDate?: string;
    generatedBy?: string;
}

